module.exports = __webpack_public_path__ + "img/p2-70.a129da28.png";